import { FormControl } from "@mui/material"
import InputTheme from "../../generic/input"
import { LangContext } from "../../../contexts/LangContext"
import { useContext, useRef } from "react"
import React from 'react';

import SearchButton from "../searchButton"
import ClearButton from "../clearButton"


export default function InputSearch({ errorText, handleBuscar, handleClose, ...props }) {
    const { lang } = useContext(LangContext)
    const refInput = useRef()

    return (
        <FormControl sx={{
            width: '100%', variant: "standard"
        }} >
            <InputTheme InputProps={{
                startAdornment: (
                    <SearchButton onClick={handleBuscar}></SearchButton>
                ),
                endAdornment: (
                    <ClearButton onClick={() => {handleClose(); refInput.current.value = ''}}></ClearButton>
                ),
            }} error={props.error} helperText={errorText ? "" : errorText} label={lang.components.generic.input_search_label} id="standard-adornment-email" variant="standard" type="text"  {...props} inputRef={refInput} />
        </FormControl>
    )
}